// Wire-Format von api/mail-kontext.js (CRM-Kontext zu einer Absenderadresse). Browser-tauglich.
import { z } from 'zod';

const Kandidat = z.object({ id: z.string(), name: z.string(), ort: z.string() });

export const MailKontextSchema = z.object({
  ok: z.literal(true),
  email: z.string(),
  match: z.object({
    art: z.enum(['kontakt', 'einrichtung', 'kostentraeger', 'domain', 'keiner']),
    sicher: z.boolean(),
    kandidaten: z.array(Kandidat).optional(),
  }),
  kontakt: z
    .object({
      id: z.string(),
      name: z.string(),
      rolle: z.string(),
      email: z.string(),
      telefon: z.string(),
    })
    .optional(),
  kostentraeger: z.object({ id: z.string(), name: z.string() }).optional(),
  einrichtung: z
    .object({
      id: z.string(),
      name: z.string(),
      art: z.string(),
      plz: z.string(),
      ort: z.string(),
      adresse: z.string(),
      kinder: z.number().nullable(),
      region: z.string(),
      telefon: z.string(),
      email: z.string(),
      status: z.string(),
      kostentraeger: z.string().nullable(),
    })
    .optional(),
  lead: z
    .object({
      id: z.string(),
      status: z.string(),
      stufe: z.string().nullable(),
      naechsterSchritt: z.string().nullable(),
      stilleTage: z.number().nullable(),
      kontaktversuche: z.number(),
      interesse: z.array(z.string()),
      wiedervorlage: z.string().nullable(),
      ferien: z.string().nullable(),
      eingang: z.string(),
    })
    .optional(),
  termine: z
    .array(
      z.object({
        id: z.string(),
        datum: z.string(),
        typ: z.string(),
        modell: z.string(),
        status: z.string(),
        staff: z.string(),
        kinderGeschaetzt: z.number().nullable(),
        allinFensterBis: z.string().nullable(),
        allinGewechseltAm: z.string().nullable(),
        crmUrl: z.string(),
      }),
    )
    .optional(),
  deals: z
    .array(
      z.object({
        id: z.string(),
        name: z.string(),
        status: z.string(),
        soll: z.number(),
        berechnet: z.number(),
        offen: z.number(),
        bezahlt: z.number(),
        unbezahlt: z.number(),
        crmUrl: z.string(),
      }),
    )
    .optional(),
  angeboteOffen: z
    .array(
      z
        .object({
          nummer: z.string(),
          status: z.string(),
          brutto: z.number(),
          datum: z.string(),
          vorgang: z.string(),
        })
        .loose(),
    )
    .optional(),
  erinnerungen: z
    .array(z.object({ id: z.string(), titel: z.string(), faellig: z.string() }).loose())
    .optional(),
  schulsongs: z.array(z.object({ id: z.string(), titel: z.string() }).loose()).optional(),
  verlauf: z
    .array(z.object({ am: z.string(), wer: z.string(), kanal: z.string(), text: z.string() }))
    .optional(),
  kontakteDerEinrichtung: z
    .array(
      z.object({
        id: z.string(),
        name: z.string(),
        rolle: z.string(),
        email: z.string(),
        telefon: z.string(),
        hauptkontakt: z.boolean(),
      }),
    )
    .optional(),
  dublettenVerdacht: z.array(Kandidat.loose()).optional(),
  crmUrl: z.string().optional(),
});
export type MailKontext = z.infer<typeof MailKontextSchema>;
